export const fabVariants = {
  open: { rotate: 45, zIndex: 20 },
  closed: { rotate: 0, zIndex: 20 }
}

export const actionsWrapperVariants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05 }
  }
}

export const actionVariants = {
  open: {
    y: 0,
    opacity: 1,
    display: "flex",
    transition: {
      duration: 0.2,
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 250,
    opacity: 1,
    display: "none",
    transition: {
      duration: 0.1,
      y: { stiffness: 1000 }
    }
  }
}
